import { Responsive } from "components/responsive";
import React from "react";

interface LoginWorkflowContainerProps {
    children: React.ReactNode;
}

export const LoginWorkflowContainer: React.FC<LoginWorkflowContainerProps> = ({
    children,
}) => {
    return (
        <>
            <Responsive />
            <div className="min-h-screen bg-gray-50">{children}</div>
        </>
    );
};
